import React from 'react';
import PropTypes from 'prop-types';

const CircleClip = ({rotate, start, stop}) => (
  <React.Fragment>
    <defs>
      <clipPath id="cut-off-bottom">
        <rect x="-1" y="-1" width="100" height="19" />
      </clipPath>
      <clipPath id="cut-off-top">
        <rect x="-1" y="18" width="100" height="19" />
      </clipPath>
    </defs>
    <g transform="rotate(315, 18, 18)">
      {rotate && <animateTransform attributeName="transform"
                        attributeType="XML"
                        type="rotate"
                        from={start}
                        to={stop}
                        dur="0.2s"
                        fill="freeze"
                        repeatCount="once"/>
      }
      <circle
        clipPath="url(#cut-off-bottom)"
        fill="rgba(0,0,0,0.5)"
        stroke="rgb(176, 74, 58)"
        strokeWidth="2"
        cx="18"
        cy="18"
        r="18"
      />
      <circle
        clipPath="url(#cut-off-top)"
        fill="rgba(0,0,0,0.5)"
        stroke="rgb(40, 58,  111)"
        strokeWidth="2"
        cx="18"
        cy="18"
        r="18"
      />
    </g>
  </React.Fragment>
);

CircleClip.propTypes = {
  rotate: PropTypes.bool,
  start: PropTypes.string,
  stop: PropTypes.string
};

export default CircleClip;